<template>
  <div class="section-login__header">
    <div class="section-login__header__bg">
      <img
        v-if="!isWhitelabel"
        src="@/assets/images/pass-recovery-bg.png"
        class="lazy"
        alt="login background"
        data-load-priority="0"
      >
      <div class="loginv2-container container">
        <h1 
          class="title md-title" 
          :class="{ 'title--ringba': !isWhitelabel }"
        >
          <span class="login-welcome-message" />
        </h1>
        <p class="subtitle">
          <span class="login-welcome-sub-message" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isWhitelabel: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style>
</style>